__turbopack_context__.v({
  "active": "Tabs-module-scss-module__gKZeCG__active",
  "content": "Tabs-module-scss-module__gKZeCG__content",
  "title": "Tabs-module-scss-module__gKZeCG__title",
});
